import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { useTrackLoggedOut } from '@air/analytics';
import { configureAPIPackage, useLogoutMutation } from '@air/utils-auth';

import { Routes } from '~/constants/Routes';
import { useWithShopifyParams } from '~/hooks/useWithShopifyParams';
import { saveShopifyParams } from '~/utils/sessionStorage';
import { windowUrlOpener } from '~/utils/urlOpeners';

export const useShopifyPluginLogout = () => {
  const router = useRouter();
  const {
    logoutMutation: { mutate },
  } = useLogoutMutation();
  const { withShopifyParams } = useWithShopifyParams();
  const { trackLoggedOut } = useTrackLoggedOut();

  const logout = useCallback(() => {
    configureAPIPackage({
      oauthConfigParams: {
        urlOpener: windowUrlOpener,
      },
    });
    saveShopifyParams(window.location.search);
    trackLoggedOut();
    mutate(
      { redirect: withShopifyParams(Routes.Login) },
      {
        onSettled: () => {
          router.replace(withShopifyParams(Routes.Login));
        },
      },
    );
  }, [mutate, router.replace, withShopifyParams, trackLoggedOut]);

  return { logout };
};
